import { Component, OnInit } from '@angular/core';
import { CurrentService } from '../../services/current.service';
import { TunnelService } from 'src/app/services/tunnel.service';
import { DatasService } from 'src/app/services/datas.service';
import { TunnelDataStore } from 'src/app/stores/tunnel/tunnel-data.store';
import { CONFIG_CONTEXT } from 'src/app/enum/config-context.enum';
import { TunnelNavigationStore } from 'src/app/stores/tunnel/tunnel-navigation.store';

@Component({
  selector: 'ng-casto-kitchen',
  templateUrl: './kitchen.component.html',
  host: { class: 'container' },
})
export class KitchenComponent implements OnInit {
  currentTabId: number = 1;

  constructor(
    public current: CurrentService,
    public tunnelService: TunnelService,
    public tunnelDataStore: TunnelDataStore,
    public datas: DatasService,
    private readonly tunnelNavigationStore: TunnelNavigationStore
  ) {}

  ngOnInit(): void {
    this.current.reset();
    this.tunnelService.reset();
    this.tunnelDataStore.resetState(false);
    this.tunnelDataStore.setMainContext(CONFIG_CONTEXT.KITCHEN);
  }

  nextTab() {
    this.currentTabId++;
  }

  start() {
    this.tunnelNavigationStore.nextStep();
  }
}
